import { render } from "./ModelContratPage.vue?vue&type=template&id=3591f2cf&ts=true"
import script from "./ModelContratPage.vue?vue&type=script&lang=ts"
export * from "./ModelContratPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__